var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center w-full mt-1_5 justify-around header-bottom__links"
    },
    [
      _vm.categories && _vm.categories.length
        ? _c(
            "div",
            {
              staticClass:
                "text-xl mr-1 relative cursor-pointer select-none z-102",
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.$emit("toggle-shop-menu", $event)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.$emit("toggle-shop-menu", $event)
                }
              }
            },
            [
              _vm._v("Shop By"),
              _c("icon-chevron-down", { staticClass: "ml-_5 text-brand" })
            ],
            1
          )
        : _vm._e(),
      _c(
        "router-link",
        {
          staticClass: "text-xl cursor-pointer z-102",
          attrs: { tabindex: "0", tag: "div", to: { name: "openShop" } }
        },
        [_vm._v("Start Selling")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }